export const SVGHeart = (
  fill?: string
) => `<svg width="100%" height="100%" fill="${fill}"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 13.999 12" enable-background="new 0 0 13.999 12" xml:space="preserve">
  <path d="M11.941,0.33c-1.783-0.825-4.115-0.049-4.94,1.73c-0.825-1.779-3.157-2.556-4.94-1.73C0.162,1.211-0.746,3.461,0.754,6.115  c1.065,1.889,2.953,3.312,6.247,5.863c3.294-2.551,5.182-3.975,6.247-5.863C14.748,3.461,13.84,1.211,11.941,0.33z"></path>
</svg>`
